import { render, staticRenderFns } from "./onboard-banner.vue?vue&type=template&id=67c1b87a&scoped=true&"
import script from "./onboard-banner.vue?vue&type=script&lang=js&"
export * from "./onboard-banner.vue?vue&type=script&lang=js&"
import style0 from "./onboard-banner.vue?vue&type=style&index=0&id=67c1b87a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1b87a",
  null
  
)

export default component.exports